<template>
    <li
    v-if="complaints.length != 0"
    class="complaints-box">
        <div class="title">
            <h1>投诉</h1>
			<el-link
			type="success "
			:underline="false"
			:href="tsurl"
			target="_blank">
			我要入驻></el-link>
            <el-link
            type="primary"
            :underline="false"
            :href="'/Index/complain_search.html?company=' + $route.query.name"
            target="_blank">
            我要投诉></el-link>
			
        </div>

        <div class="con complaints">
            <a
            v-for="(i, index) in complaints.slice(0, 3)"
            :key="index"
            class="cate"
            :href="'/Index/complain_detail.html?id=' + i.id"
            target="_blank">
                <p class="province">{{i.category}}</p>
                <p class="time">{{i.ctime}}</p>
                <h1 v-if="i.title != ''">【电诉宝】{{i.title}}</h1>
                <p class="text">{{i.remark2}}</p>
                <div class="type">
                    <span>[投诉对象] <strong>{{i.to_company}}</strong></span>
                    <span>领域：<strong>{{i.remark}}</strong></span>
                    <span>类型：<strong>{{i.concrete_area}}</strong></span>
                </div>
                <div class="progress">
                    <span :class="[i.state== '不予受理' ? 'gray': '', i.state== '未审核' ? 'gray': '', i.state== '受理无效' ? 'gray': '', i.state== '已移交' ? 'orange': '', i.state== '已受理' ? 'green': '', i.state== '已评价' ? 'red': '',]">{{i.state}}</span>
                </div>
            </a>
        </div>
    </li>
</template>

<script>
export default {
    name: 'complaints',
    data() {
        return {
            filter: [
                // 'EBAY中国香港',
                // '快手'
            ],
            complaints: [],
			tsurl:'http://show.s.315.100ec.cn/'
        }
    },
    created() {
        if(this.filter.includes(this.$route.query.name)) {
            return
        }

        axios.get('http://www.315.100ec.cn/api/index.php?_a=product&f=complain&page_record=6&state=&p=0&to_company=' + this.$route.query.name)
        .then((res) => {
            if(res.data.pw_rec_list.length != 0) {
                res.data.pw_rec_list.forEach(item => {
                    if(item.state == 0){
				        item.state = "不予受理"
			        }else if(item.state == 1){
				        item.state = "未审核"
			        }else if(item.state == 2){
				        item.state = "已移交"
			        }else if(item.state == 3){
				        item.state = "已受理"
			        }else if(item.state == 4){
						item.state = "已评价"
					}else if(item.state == 5){
				        item.state = "受理无效"
			        }

                    if(item.cdate.slice(0,4) >= 2018) {
                        this.complaints.push(item)
                    }
                })
            }
        })
    }
}
</script>

<style scoped>
.cate {
    display: block;
    color: #2c3e50;
    border-bottom: #dcdfe6 solid 1px;
    position: relative;
    padding: 20px;
    margin-bottom: 20px;
    transition: all .3s ease;
}
.cate:hover {
    background: #eee;
}
.cate .time {
    color: #ccc;
    line-height: 30px;
}
.cate h1 {
    font-size: 18px;
    color: #409eff;
}
.cate .text {
    line-height: 24px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    padding: 20px 0 30px;
}
.cate .type {
    display: flex;
}
.cate .type span {
    margin-right: 30px;
}
.cate .type strong {
    color: #409eff;
}
.cate .progress span {
    width: 100px;
    color: #fff;
    text-align: center;
    line-height: 2;
    border-radius: 2px;
    position: absolute;
    top: 10px;
    right: 10px;
}
.cate .gray {
    background: gray;
}
.cate .orange {
    background: orange;
}
.cate .green {
    background: green;
}
.cate .red {
    background: red;
}

@media(max-width: 868px) {
    .cate,
    .cate .text {
        padding: 0;
    }
    .cate .progress span {
        width: 60px;
        font-size: 12px;
    }
    .cate .type {
        padding: 15px 0;
    }
    .cate .type span {
        margin: 0;
        display: block;
    }
}
</style>